const ShapeToolIcon = ({ isActive, size = "24px" }: any) => {
  const finalColor = isActive ? "white" : "#0C172C";

  return (
    <svg width={size} height={size} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.182861 5.80762C0.426878 5.56365 0.822572 5.56375 1.06665 5.80762L5.00024 9.74121V6.25H13.1252V14.375H9.63403L12.9417 17.6826C13.1856 17.9267 13.1856 18.3224 12.9417 18.5664C12.6976 18.8104 12.3019 18.8104 12.0579 18.5664L0.182861 6.69141C-0.0610226 6.44731 -0.0611517 6.05163 0.182861 5.80762ZM6.25024 10.8857C6.25021 10.9184 6.24533 10.9501 6.24048 10.9814L8.38403 13.125H11.8752V7.5H6.25024V10.8857ZM15.1829 0C16.9088 0 18.3079 1.39911 18.3079 3.125C18.3077 4.85077 16.9087 6.25 15.1829 6.25C13.4571 6.24992 12.058 4.85072 12.0579 3.125C12.0579 1.39916 13.457 8.09982e-05 15.1829 0ZM15.1829 1.25C14.1474 1.25008 13.3079 2.08952 13.3079 3.125C13.308 4.16037 14.1475 4.99992 15.1829 5C16.2183 5 17.0577 4.16042 17.0579 3.125C17.0579 2.08947 16.2184 1.25 15.1829 1.25Z"
        fill={finalColor}
      />
    </svg>
  );
};

export default ShapeToolIcon;
